const WEBXR_ACTIVE_CLASS = "webxr-active";

export function setWebXrDomOverlayActive(active: boolean, root: HTMLElement = document.documentElement): () => void {
  root.classList.toggle(WEBXR_ACTIVE_CLASS, active);
  return () => root.classList.remove(WEBXR_ACTIVE_CLASS);
}
